import { objectWithoutKeys } from './objectWithoutKeys';
import { Entity, EntityMap } from './types';

/**
 * Replaces these entities in the map of fulfilled entities, and removes them from the map of pending entities.
 */
export const replaceFulfilled: <T extends Entity>(state: EntityMap<T>, entities?: Record<string, T>) => EntityMap<T> = (
  state,
  entities = {}
) => {
  const newPending = objectWithoutKeys<boolean>(state.pending.byId, Object.keys(entities));

  return {
    ...state,
    pending: {
      ...state.pending,
      byId: newPending,
    },
    fulfilled: {
      ...state.fulfilled,
      byId: entities,
    },
  };
};
